import React from "react";
import { Box, Flex } from "theme-ui";

import PaymentInfo from "pages/Goods/components/PaymentInfo";
import ProductItem from "pages/Goods/components/ProductList/ProductItem";
import { useAppSelector } from "store/hooks";
import { getGoodsList } from "store/productPayment/goods";

function ProductList() {
  const goodsList = useAppSelector(getGoodsList);

  return (
    <Box
      sx={{
        height: "calc(100% - 55px)",
        padding: "0 15px 0 15px",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          borderRadius: "10px",
          backgroundColor: "#fff",
          boxShadow: "0 5px 10px rgb(0 0 0 / 15%)",
          height: "calc(100% - 210px)",
          padding: "0 10px",
          overflowY: "scroll",
        }}
      >
        {goodsList.map((goods) => (
          <ProductItem id={goods.productTID} key={goods.productTID} />
        ))}
      </Box>
      <PaymentInfo />
      <Flex
        sx={{
          color: "#888",
          fontSize: "12px",
          textAlign: "center",
        }}
      >
        <Box sx={{ textAlign: "left" }}>
          이용약관 | 개인정보처리방침
          <br />
          주식회사 아치서울 | 박세환
          <br />
          사업자번호 : 804-81-01036
          <br />
          통신판매업신고:2019-서울강남-02838
          <br />
          서울시 마포구 양화로 186, 606호
          <br />
          고객센터 : 02-6205-0122
        </Box>
      </Flex>
    </Box>
  );
}

export default ProductList;
